import { Col, Form, Row } from "react-bootstrap"
import "react-datepicker/dist/react-datepicker.css"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import {
    getContractorsPollutionCoverage,
    getMoldCoverages,
    getNonOwnedDisposalSiteCoverages,
    getProfessionalLiabilityCoverage
} from "../../../../data/enumSlice"

const PollutionAndProfessional = ({ applicationData, updateApplication, validationError, priorPolicy }) => {
    const dispatch = useDispatch()
    const {
        professionalLiabilityCoverages,
        nonOwnedDisposalSiteCoverages,
        contractorsPollutionCoverage,
        moldCoverages
    } = useSelector((state) => state.enums)

    useEffect(() => {
        !professionalLiabilityCoverages?.length && dispatch(getProfessionalLiabilityCoverage())
        !nonOwnedDisposalSiteCoverages?.length && dispatch(getNonOwnedDisposalSiteCoverages())
        !contractorsPollutionCoverage?.length && dispatch(getContractorsPollutionCoverage())
        !moldCoverages?.length && dispatch(getMoldCoverages())
    }, [])

    return (
        <Form>
            <Form.Group
                as={Row}
                md={12}
                className="mt-3 mx-1">
                <Form.Label className="fw-bold">
                    Does the Applicant currently have Contractors Pollution Liability or Contractors Pollution Liability
                    and Professional Liability Coverage?
                </Form.Label>

                <Form.Check
                    type="radio"
                    label="Yes"
                    name="doesTheApplicationCurrentlyHaveLiabilityCoverage"
                    value={true}
                    checked={applicationData?.doesTheApplicationCurrentlyHaveLiabilityCoverage === true}
                    onChange={updateApplication}
                />
                <Form.Check
                    type="radio"
                    name="doesTheApplicationCurrentlyHaveLiabilityCoverage"
                    value={false}
                    label="No"
                    checked={applicationData?.doesTheApplicationCurrentlyHaveLiabilityCoverage === false}
                    onChange={updateApplication}
                />
                {validationError?.doesTheApplicationCurrentlyHaveLiabilityCoverage && (
                    <div className="text-error">Please select one of above options.</div>
                )}
            </Form.Group>

            {(applicationData?.doesTheApplicationCurrentlyHaveLiabilityCoverage ?? true) && (
                <>
                    <Form.Label className="fw-bold">Please provide Retroactive date for the following:</Form.Label>
                    <Form.Group md={12}>
                        <Row>
                            <Col md={6}>
                                <Form.Label>Professional Liability Coverage:</Form.Label>
                                <Form.Select
                                    className={`form-select-sm ${
                                        validationError?.professionalLiabilityCoverage ? "error" : ""
                                    }`}
                                    name="professionalLiabilityCoverage"
                                    value={applicationData?.professionalLiabilityCoverage ?? ""}
                                    onChange={updateApplication}>
                                    <option value="">--- Select ---</option>
                                    {professionalLiabilityCoverages?.map((professionalLiabilityCoverage) => (
                                        <option
                                            key={professionalLiabilityCoverage?.value}
                                            value={professionalLiabilityCoverage?.value}>
                                            {professionalLiabilityCoverage?.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            {applicationData?.professionalLiabilityCoverage ===
                                "CurrentProfessionalLiabilityCoverageRetroactiveDate" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        className={`form-select-sm ${
                                            validationError?.professionalLiabilityCoverageRetroactiveDate ? "error" : ""
                                        }`}
                                        type="date"
                                        name="professionalLiabilityCoverageRetroactiveDate"
                                        value={
                                            applicationData?.professionalLiabilityCoverageRetroactiveDate
                                                ? new Date(applicationData.professionalLiabilityCoverageRetroactiveDate)
                                                      .toISOString()
                                                      .slice(0, 10)
                                                : ""
                                        }
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )}
                        </Row>
                    </Form.Group>
                    <Form.Group md={12}>
                        <Row>
                            <Col md={6}>
                                <Form.Label>Contractors Pollution Coverage:</Form.Label>
                                <Form.Select
                                    className={`form-select-sm ${
                                        validationError?.contractorsPollutionCoverage ? "error" : ""
                                    }`}
                                    name="contractorsPollutionCoverage"
                                    value={applicationData?.contractorsPollutionCoverage ?? ""}
                                    onChange={updateApplication}>
                                    <option value="">--- Select ---</option>
                                    {contractorsPollutionCoverage?.map((contractorsPollutionCoverage) => {
                                        if (contractorsPollutionCoverage?.value === "None") {
                                            return null
                                        }
                                        return (
                                            <option
                                                key={contractorsPollutionCoverage?.value}
                                                value={contractorsPollutionCoverage?.value}>
                                                {contractorsPollutionCoverage?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </Col>
                            {applicationData?.contractorsPollutionCoverage ===
                                "CurrentContractorsPollutionCoverageRetroactiveDate" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        className={`form-select-sm ${
                                            validationError?.contractorsPollutionCoverageRetroactiveDate ? "error" : ""
                                        }`}
                                        type="date"
                                        name="contractorsPollutionCoverageRetroactiveDate"
                                        value={
                                            applicationData?.contractorsPollutionCoverageRetroactiveDate
                                                ? new Date(applicationData.contractorsPollutionCoverageRetroactiveDate)
                                                      .toISOString()
                                                      .slice(0, 10)
                                                : ""
                                        }
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )}
                        </Row>
                    </Form.Group>
                    <Form.Group md={12}>
                        <Row>
                            <Col md={6}>
                                <Form.Label>Non-Owned Disposal Site Coverage:</Form.Label>
                                <Form.Select
                                    className={`form-select-sm ${
                                        validationError?.nonOwnedDisposalSiteCoverage ? "error" : ""
                                    }`}
                                    name="nonOwnedDisposalSiteCoverage"
                                    value={applicationData?.nonOwnedDisposalSiteCoverage ?? ""}
                                    onChange={updateApplication}>
                                    <option value="">--- Select ---</option>
                                    {nonOwnedDisposalSiteCoverages?.map((nonOwnedDisposalSiteCoverage) => {
                                        if (nonOwnedDisposalSiteCoverage?.value === "None") {
                                            return null
                                        }
                                        return (
                                            <option
                                                key={nonOwnedDisposalSiteCoverage?.value}
                                                value={nonOwnedDisposalSiteCoverage?.value}>
                                                {nonOwnedDisposalSiteCoverage?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </Col>
                            {applicationData?.nonOwnedDisposalSiteCoverage ===
                                "CurrentNonOwnedDisposalSiteCoverageRetroactiveDate" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        className={`form-select-sm ${
                                            validationError?.nonOwnedDisposalSiteCoverageRetroactiveDate ? "error" : ""
                                        }`}
                                        type="date"
                                        name="nonOwnedDisposalSiteCoverageRetroactiveDate"
                                        value={
                                            applicationData?.nonOwnedDisposalSiteCoverageRetroactiveDate
                                                ? new Date(applicationData.nonOwnedDisposalSiteCoverageRetroactiveDate)
                                                      .toISOString()
                                                      .slice(0, 10)
                                                : ""
                                        }
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )}

                            {/* {applicationData?.nonOwnedDisposalSiteCoverage ===
                                "OccurrenceNonOwnedDisposalSiteCoverageCurrentlyInPlace" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        type="text"
                                        className="form-select-sm"
                                        name="nonOwnedDisposalSiteCoverageInPlace"
                                        value={applicationData?.nonOwnedDisposalSiteCoverageInPlace} //TODO: Add this name in the API
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )} */}
                        </Row>
                    </Form.Group>
                    <Form.Group md={12}>
                        <Row>
                            <Col md={6}>
                                <Form.Label>Mold Coverage:</Form.Label>
                                <Form.Select
                                    className={`form-select-sm ${validationError?.moldCoverage ? "error" : ""}`}
                                    name="moldCoverage"
                                    value={applicationData?.moldCoverage ?? ""}
                                    onChange={updateApplication}>
                                    <option value="">--- Select ---</option>
                                    {moldCoverages?.map((moldCoverage) => {
                                        if (moldCoverage?.value === "None") {
                                            return null
                                        }
                                        return (
                                            <option
                                                key={moldCoverage?.value}
                                                value={moldCoverage?.value}>
                                                {moldCoverage?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </Col>
                            {applicationData?.moldCoverage === "CurrentMoldCoverageRetroactiveDate" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        className={`form-select-sm ${
                                            validationError?.moldCoverageRetroactiveDate ? "error" : ""
                                        }`}
                                        type="date"
                                        name="moldCoverageRetroactiveDate"
                                        value={
                                            applicationData?.moldCoverageRetroactiveDate
                                                ? new Date(applicationData.moldCoverageRetroactiveDate)
                                                      .toISOString()
                                                      .slice(0, 10)
                                                : ""
                                        }
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )}

                            {/* {applicationData?.moldCoverage ===
                                "OccurrenceNonOwnedDisposalSiteCoverageCurrentlyInPlace" && (
                                <Col
                                    md={6}
                                    className="mt-4">
                                    <Form.Control
                                        type="text"
                                        className="form-select-sm"
                                        name="moldCoverageInPlace"
                                        value={applicationData?.moldCoverageInPlace || ""} //TODO: Add this name in the API
                                        onChange={updateApplication}
                                    />
                                </Col>
                            )} */}
                        </Row>
                    </Form.Group>
                </>
            )}
        </Form>
    )
}

export default PollutionAndProfessional
